import { render, staticRenderFns } from "./final-questions.vue?vue&type=template&id=afe394c6&scoped=true"
import script from "./final-questions.vue?vue&type=script&lang=js"
export * from "./final-questions.vue?vue&type=script&lang=js"
import style0 from "./final-questions.vue?vue&type=style&index=0&id=afe394c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe394c6",
  null
  
)

export default component.exports